module.exports = __webpack_public_path__ + "static/high-performance-2b2584fcaa2bfc25f6ec656fa820f83b.svg";